var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$isEmpty(_vm.cfhTips))?_c('div',{staticClass:"tip-box",on:{"click":_vm.$goFundApp}},_vm._l((_vm.cfhTips),function(tip,index){return _c('div',{key:index,staticClass:"tip-item"},[_vm._v(_vm._s(tip.content))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }